import Dashboard from '../../views/Dashboard';
import pages from '../pages';

export const Route404 = [
  {
    path: pages.NOT_FOUND.path,
    component: Dashboard
  }
];
